module.exports = __webpack_public_path__ + "img/logo-full.e554a0dd.png";